// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/parseFloat#Polyfill
if (Number.parseFloat === undefined) {
  Number.parseFloat = parseFloat;
}
